import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import PdfLinkActions from "src/components/PdfLinkActions";
import MoveConfirmationImage from "../../../../assets/images/move_confirmation.webp";

export default function MoveConfirmationModal({
  open,
  onClose,
  itemType = "item",
  locations = [],
  warehouseName = "",
  mobileLocation,
}) {
  if (!open) return null;

  const typeLabel = itemType === "mobile" ? "mobile location" : itemType;
  const locationText = Array.isArray(locations) ? locations.join(", ") : locations;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <Box bgcolor="#f4f6f8" position="relative">
        <DialogTitle sx={{ display: "flex", justifyContent: "center", bgcolor: "#f4f6f8" }}>
          <Typography fontSize={24} fontWeight={500} color="textPrimary" align="center">
            Move Confirmed
          </Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{ position: "absolute", right: 10, top: 10 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
      </Box>
      <DialogContent sx={{ background: "#f4f6f8" }}>
        <Box display="flex" justifyContent="center" mt={2}>
          <Box
            component="img"
            src={MoveConfirmationImage}
            borderRadius={3}
            width="100%"
            maxWidth={300}
            minHeight="100px"
            alt="Move Locations"
          />
        </Box>
        <Box display="flex" flexDirection="column" alignItems="center" mt={4}>
          <Typography align="center" color="text.secondary" sx={{ mb: 2, maxWidth: 400, fontSize: 18 }}>
            {typeLabel === "items" ? "These" : "This"} {typeLabel} can now be found in:
          </Typography>
          <Typography align="center" color="text.primary" fontWeight={500} sx={{ mb: 4, maxWidth: 400, fontSize: 18 }}>
            {locationText}{warehouseName && ` within the ${warehouseName}`}
          </Typography>
          {mobileLocation && (
            <PdfLinkActions
              resourceType="mobile_warehouse_location_pdfs"
              resourceId={mobileLocation?.id}
              label="View Location PDF"
              variant="text"
              color="primary"
              sx={{ mb: 2 }}
            />
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
